import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import layoutTop from "./layout/top.vue"; // 头部区域
import layoutPreview from "./layout-preview/index.vue"; // 组件预览区域

import layoutComponentList from "./layout/left.vue"; // 组件列表区域
import layoutSortable from "./layout/right.vue"; // 组件顺序区域
import zoom from "./layout/zoom.vue"; // 放大缩小
import backtop from './layout/backtop';
import config from '@/config';
import { mapGetters, mapState } from "vuex";
import "./index.scss";
function modifyPaste(e) {
  e.preventDefault(); // 阻止默认的粘贴行为// 获取粘贴的文本内容
  var pastedText = '';
  if (window.clipboardData && window.clipboardData.getData) {
    // 兼容IE
    pastedText = window.clipboardData.getData('Text');
  } else if (e.clipboardData && e.clipboardData.getData) {
    pastedText = e.clipboardData.getData('text/plain');
  }

  // 修改粘贴的内容

  var modifiedText = decodeURIComponent(pastedText);

  // 将修改后的内容放回剪贴板
  if (window.clipboardData && window.clipboardData.setData) {
    // 兼容IE
    window.clipboardData.setData('Text', modifiedText);
  } else if (e.clipboardData && e.clipboardData.setData) {
    e.clipboardData.setData('text/plain', modifiedText);
  }

  // 在输入框中插入修改后的内容
  document.execCommand('insertText', false, modifiedText);
  console.log('修改粘贴内容', {
    pastedText: pastedText,
    modifiedText: modifiedText
  });
}
export default {
  i18n: require('./design_i18n'),
  components: {
    layoutTop: layoutTop,
    layoutPreview: layoutPreview,
    layoutComponentList: layoutComponentList,
    layoutSortable: layoutSortable,
    zoom: zoom,
    backtop: backtop
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    first_loaded: function first_loaded(state) {
      return state.design.first_loaded;
    },
    loading: function loading(state) {
      return state.design.loading;
    },
    rootSize: function rootSize(state) {
      return state.design.rootSize;
    }
    // platform: (state) => state.page.info.platform,
  })), {}, {
    platform: function platform() {
      return this.$store.getters['design/getPlatform'];
    }
  }),
  mounted: function mounted() {
    document.documentElement.style.fontSize = this.rootSize;

    // window.addEventListener('paste', modifyPaste)
  },
  destroyed: function destroyed() {
    window.removeEventListener('paste', modifyPaste);
  },
  methods: {
    /**
     * 页面初始化
     */
    page_init: function page_init() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // this.$store.dispatch('design/pageInit')

              // 请求页面数据
              _this.$store.dispatch("design/page_load", _this.platform);
              _this.$message.config({
                top: '70px'
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  },
  data: function data() {
    return {
      curPlatform: 'pc'
    };
  },
  watch: {
    rootSize: function rootSize() {
      document.documentElement.style.fontSize = this.rootSize;
    }
  },
  created: function created() {
    var lang = window.localStorage.lang || config.lang;
    this.$i18n.locale = lang;
    this.$store.commit('setting/setLang', lang);
    /**
     * 页面初始化
     */
    this.$store.dispatch("design/registerComponents");
    var p = window.localStorage.platform;
    if (p) {
      this.$store.dispatch('design/setPlatform', p);
    }
    this.page_init();
  }
};